import { Controller } from 'stimulus'
import { removeCoupon } from '~/site/pages/cart/coupons'
export default class extends Controller {
  removeCoupon({ params: { couponCode, fieldName } }) {
    removeCoupon(fieldName, couponCode)
  }
}
